/** Import modules */

import { useTranslation }   from "react-i18next";

import { Helmet }           from "react-helmet-async";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                           from "../../Components/SEO/localizedMeta";

/** Import components */

import Breadcrumbs          from "../../Components/Layout/Header/Breadcrumbs";

import Layout               from "../../Components/Services/Layout";

import List                 from "../../Components/Services/Services";

/**
 * 
 * @returns Services page
 * 
 */

const Services = () => { const { t, i18n } = useTranslation (),

    currentLanguage = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language),

    canonicalHref = localizedAbsoluteUrl("/content/services", currentLanguage),

    alternateLinks = hreflangLinks("/content/services"),

    pageDescription = localizedValue({
        lv: "Autoservisa pakalpojumi Tireshop.lv - riepu montāža, balansēšana, remonts, sezonas maiņa un citi servisa darbi. Izvēlies vajadzīgāko pakalpojumu tiešsaistē.",
        en: "Car service at Tireshop.lv: tire fitting, balancing, repair, seasonal replacement, and more. Choose the required service online.",
        ru: "Услуги автосервиса Tireshop.lv: монтаж шин, балансировка, ремонт, сезонная замена и другие работы. Выберите нужную услугу онлайн."
    }, currentLanguage);

    /** Render component */

    return ( <div className="container max-content-width">

        <Helmet>

            <title>{ `Tireshop.lv | ${ t ( "services" ) }` }</title>

            <meta
                name="description"
                content={ pageDescription }
            />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "services" ), URI: `/${ t ( "__permalink_content__" ) }/${ t ( "__permalink_services__" ) }` }

        ] } />

        <Layout title={ t ( "services" ) }>

            <List />

        </Layout>
        
    </div> );

}

/** Export component */
 
export default Services;
